import {PdvModel} from "../../Models/PdvModel";

export const door1PdvsMock: PdvModel[] = [
    {
        id: 144,
        name: "AGENCE2WEB - DEV",
        image: "https://firebasestorage.googleapis.com/v0/b/appero-19fa0.appspot.com/o/topivo%2Fstands%2Fstand3.jpeg?alt=media&token=4422c390-6886-4146-8c48-a00309885537",
        bartPickup: {
            id: 0,
            name: '114'
        },
        affluence: "5-10"
    },
    {
        id: 145,
        name: "stand vide",
        image: "https://firebasestorage.googleapis.com/v0/b/appero-19fa0.appspot.com/o/topivo%2Fstands%2Fstand3.jpeg?alt=media&token=4422c390-6886-4146-8c48-a00309885537",
        bartPickup: {
            id: 0,
            name: '114'
        },
        affluence: "10-15"
    }
]
